import styled from 'styled-components'

export const OurStoryWrapper = styled.section`
	position: relative;
	padding: 80px 15px;

	&::before {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		background: #f6f4f2;
		height: 50px;
	}

	&::after {
		content: '';
		border-bottom-left-radius: 50% 100%;
		border-bottom-right-radius: 50% 100%;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		background: #fff;
		height: 50px;
		box-shadow: 0px 5px 4px rgba(125, 125, 125, 0.15);
	}
`

export const SectionContent = styled.article`
	max-width: 800px;
	margin: 0 auto;
	font-family: 'Roboto Serif', serif;
`

export const SectionImage = styled.img`
	max-width: 200px;
	padding: 20px 0 10px 20px;
`
